import React, { forwardRef, useState } from 'react';
import { InputText, InputTextProps } from 'primereact/inputtext';
import './PasswordInput.scss';

interface PasswordInputProps extends Omit<InputTextProps, 'type'> {}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...rest }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className="password-input">
        <InputText
          ref={ref}
          type={visible ? 'text' : 'password'}
          className={className}
          {...rest}
        />
        <button
          type="button"
          className="password-input__toggle"
          onClick={() => setVisible((v) => !v)}
          tabIndex={-1}
        >
          <span className={`ico ${visible ? 'ico--eye-off' : 'ico--eye'} ico--xs`} />
        </button>
      </div>
    );
  }
);
